module.exports = __webpack_public_path__ + "media/mapviewActive.98c39ac4.svg";